export const OpcionesDeEstadoLaboral = [
  {
    key: 0,
    text: 'Desempleado',
    value: 'Desempleado',
    valueToSend: false
  },
  {
    key: 1,
    text: 'Empleado',
    value: 'Empleado',
    valueToSend: true
  },

]
